import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import Form from '../../../../components/form/Form';
import React, { useEffect, useState } from 'react';
import { AdresseModel } from '../../../../models/AdresseModel';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import Select from '../../../../components/select/Select';
import { LandModel } from '../../../../models/LandModel';
import { getLaender } from '../../../../redux/actions/laender';
import { setAdresseField } from '../../../../redux/actions/adresserfassung';
import { searchOrte } from '../../../../redux/actions/orte';
import { AutocompleteFormatOrtsname } from './search/AutocompleteFormatOrtsname';
import { clearSuchvorschlaege } from '../../../../redux/actions/adresse';
import { AutocompleteFormatPLZ } from './search/AutocompleteFormatPLZ';
import { Adresse, Land } from '../../../../api';
import { nameof } from '../../../../utils/objectUtils';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import { ConfigModel } from '../../../../models/ConfigModel';

interface AnschriftProps {
  adresse: AdresseModel;
  laender: LandModel[];
  suchvorschlaege: [];
  getLaender: () => void;
  setAdresseField: (value: any, fieldName: string) => void;
  searchOrte: (ortsname?: string, plz?: string, landId?: number) => void;
  clearSuchvorschlaege: () => void;
  config: ConfigModel;
}

const Anschrift = (props: AnschriftProps) => {
  const [focusedField, setFocusedField] = useState('');

  const [laender, setLaender] = useState<LandModel[]>([]);

  const [ortsname, setOrtsname] = useState('');
  const [plz, setPlz] = useState('');
  const [lkz, setLkz] = useState('');

  useEffect(() => {
    props.getLaender();
  }, []);

  useEffect(() => {
    setLaender(props.laender);
  }, [props.laender]);

  useEffect(() => {
    setOrtsname(props.adresse.ort);
  }, [props.adresse.ort]);

  useEffect(() => {
    setPlz(props.adresse.plz);
  }, [props.adresse.plz]);

  useEffect(() => {
    setLkz(props.adresse.lkz);
  }, [props.adresse.lkz]);

  const autocompleteHandler = (suchvorschlag: any) => {
    props.setAdresseField(suchvorschlag.ortsname, nameof<Adresse>('ort'));
    props.setAdresseField(suchvorschlag.plz, nameof<Adresse>('plz'));

    props.setAdresseField(
      props.laender.filter(land => land.lkz === suchvorschlag.lkz)[0],
      nameof<Adresse>('land')
    );

    setOrtsname(suchvorschlag.ortsname);
    setPlz(suchvorschlag.plz);
    setLkz(suchvorschlag.lkz);

    props.clearSuchvorschlaege();
  };

  useEffect(() => {
    props.setAdresseField(ortsname, nameof<Adresse>('ort'));
    props.searchOrte(ortsname, '', props.adresse?.land?.id);
  }, [ortsname]);

  useEffect(() => {
    props.setAdresseField(plz, nameof<Adresse>('plz'));
    props.searchOrte('', plz, props.adresse?.land?.id);
  }, [plz]);

  useEffect(() => {
    props.setAdresseField(lkz, nameof<Adresse>('lkz'));
  }, [lkz]);

  useEffect(() => {
    if (!ortsname)
      setOrtsname(
        props.adresse &&
          props.adresse.ort &&
          focusedField !== nameof<Adresse>('ort')
          ? props.adresse.ort
          : ''
      );

    if (!plz)
      setPlz(
        props.adresse &&
          props.adresse.plz &&
          focusedField !== nameof<Adresse>('plz')
          ? props.adresse.plz
          : ''
      );
  }, [props.adresse]);

  const plzChangeHandler = (value: string) => {
    if (value.trim() === '') {
      props.setAdresseField('', focusedField);
    }
    setPlz(value);
    clearSuchvorschlaege();
  };

  const ortChangeHandler = (value: string) => {
    if (value.trim() === '') {
      props.setAdresseField('', focusedField);
    }
    setOrtsname(value);
    clearSuchvorschlaege();
  };

  return (
    <Form classes='adr-anschrift-form'>
      <div id='adr-lkz-plz-ort'>
        <Select
          className='adr-lkz'
          headerTitle='LKZ'
          name={nameof<Adresse>('lkz')}
          onChangeHandler={(id?: number) => {
            const land = laender.find(land => land.id === id);
            props.setAdresseField(land, nameof<Adresse>('land'));
            props.setAdresseField(land?.lkz ?? '', nameof<Adresse>('lkz'));
          }}
          selectedOptionId={props.adresse.land?.id ?? undefined}
          selectData={toSelectOptions(laender, nameof<Land>('lkz'), false)}
          filterList
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
        <InputFieldText
          label='PLZ'
          name={nameof<Adresse>('plz')}
          maxlength={9}
          classes='adr-plz'
          value={plz}
          parentFocusHandler={setFocusedField}
          onChangeHandler={plzChangeHandler}
          autocompleteFormat={<AutocompleteFormatPLZ />}
          autocompleteHandler={autocompleteHandler}
          suchvorschlaege={props.suchvorschlaege}
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
        <InputFieldText
          label='Ort'
          name={nameof<Adresse>('ort')}
          maxlength={35}
          classes='adr-ort'
          value={ortsname}
          parentFocusHandler={setFocusedField}
          onChangeHandler={ortChangeHandler}
          autocompleteFormat={<AutocompleteFormatOrtsname />}
          autocompleteHandler={autocompleteHandler}
          suchvorschlaege={props.suchvorschlaege}
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
      </div>
      <InputFieldText
        label='Ortsteil'
        name={nameof<Adresse>('ortsteil')}
        maxlength={35}
        classes='adr-ortsteil'
        value={props.adresse.ortsteil}
        onChangeHandler={value => props.setAdresseField(value, 'ortsteil')}
        readonly={
          !!props.adresse.inUebertragung ||
          (!!props.adresse.inUebertragung &&
            (props.config.isAdresseTelefonEdit ||
              props.config.isAdresseKontaktEdit ||
              props.config.isAdresseUnsichtbarEdit ||
              props.config.isAdresseEinmaladresseEdit))
        }
      />

      <div id='adr-strasse-haus-nr'>
        <InputFieldText
          label='Strasse'
          name={nameof<Adresse>('strasse')}
          maxlength={35}
          classes='adr-strasse'
          value={props.adresse.strasse}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('strasse'))
          }
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
        <InputFieldText
          label='Hausnummer'
          name={nameof<Adresse>('hausnummer')}
          maxlength={10}
          classes='adr-haus-nr'
          value={props.adresse.hausnummer}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('hausnummer'))
          }
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
      </div>
      <InputFieldText
        label='Zusatz'
        name={nameof<Adresse>('zusatz')}
        maxlength={5}
        classes='adr-zusatz'
        value={props.adresse.zusatz}
        onChangeHandler={value =>
          props.setAdresseField(value, nameof<Adresse>('zusatz'))
        }
        readonly={
          !!props.adresse.inUebertragung ||
          (!!props.adresse.inUebertragung &&
            (props.config.isAdresseTelefonEdit ||
              props.config.isAdresseKontaktEdit ||
              props.config.isAdresseUnsichtbarEdit ||
              props.config.isAdresseEinmaladresseEdit))
        }
      />
    </Form>
  );
};

const mapStateToProps = (state: StateModel) => ({
  adresse: state.Adresserfassung,
  laender: state.Stammdaten.laender,
  suchvorschlaege: state.Stammdaten.suchvorschlaege,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getLaender,
  setAdresseField,
  searchOrte,
  clearSuchvorschlaege,
})(Anschrift);
